import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { callAPI, decryptToken, hasRoles } from '../../components/utils';
import Timer from '../../components/timer';
import TutorDashboard from './components/tutorDashboard';
import { Grid, Typography } from '@mui/material';
import { useSidebarContext } from '../../context/SidebarContext';

const Home = ({ setLoginStatus }) => {
  const [token, setToken] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const navigate = useNavigate();

  const checkTokenValidity = useCallback(async () => {
    try {
      const decodedToken = decryptToken();

      if (decodedToken) {
        setTimeLeft(decodedToken.exp * 1000);
      } else {
        console.warn('Token has expired');
        navigate('/login');
      }
    } catch (error) {
      console.error('Error during token decryption/validation:', error.message);
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const savedToken = localStorage.getItem('authToken');
    if (!savedToken) {
      navigate('/login');
    } else {
      setToken(savedToken);
      checkTokenValidity();
    }
  }, [navigate, checkTokenValidity]);

   const [isAdmin, setIsAdmin] = useState(false);
    const [isTutor, setIsTutor] = useState(false);
    const [isOwner, setIsOwner] = useState(false);
  
    useEffect(() => {
      try {
        setIsAdmin(hasRoles('Admin'));
        setIsTutor(hasRoles('Tutor'));
        setIsOwner(hasRoles('Owner'));
      } catch (error) {
        console.error('Error fetching user roles:', error);
      }
    }, []);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setToken(null);
    setLoginStatus(false);
    navigate('/login');
  };

  const onTimerFinish = () => {
    console.warn('Session expired, logging out');
    //handleLogout();
  };

  return (
    <div>
      {token ? (
        isTutor && !isOwner ? (
          <Grid>
          <Typography variant="h2" mb={2}>Dashboard</Typography>
          <TutorDashboard />
        </Grid>
        ) : 
        <div>
          <h2>Welcome!</h2>
          <p>You are logged in.</p>
          {/* <p>Your token: {token}</p> */}

          {timeLeft ? (
            <div>
              <p>
                Session Time Left:{" "}
                <Timer initialTimeLeft={timeLeft} onFinish={onTimerFinish} />
              </p>
            </div>
          ) : (
            <p>Loading session time...</p>
          )}

        </div>
        
      ) : (
        <p>Redirecting to login...</p>
      )}
    </div>
  );
};

export default Home;
